<template>
  <div class="posterWrapper">
    <img :src="posterUrl" ref="poster" alt="" class="posterImg">
    <canvas class="posterCanvas" ref="posterCanvas" width="500" height="800"></canvas>
    <div class="qrcode" ref="qrcode"></div>
  </div>
</template>

<script>
import QRCode from '@/utils/qrcode.js'
export default {
  props: {
    imgUrl: String, /*背景图片链接*/
    QRCodeMsg: String  /*二维码信息*/
  },
  data(){
    return {
      posterUrl: ''
    }
  },
  watch: {
    imgUrl: function (newval, oldval) {
      if((newval != oldval) && newval){
        this.drawPoster()
      }
    },
    QRCodeMsg: function (newval, oldval) {
      if((newval != oldval) && newval){
        this.drawPoster()
      }
    }
  },
  mounted(){
    this.drawPoster()
  },
  methods: {
    drawPoster(){
      if(this.imgUrl && this.QRCodeMsg){
        let canvas = this.$refs.posterCanvas
        const context = canvas.getContext('2d')
        context.rect(0, 0, canvas.width, canvas.height)
        context.fillStyle = '#fff'
        context.fill()
        let imgNew = new Image()
        imgNew.src = this.imgUrl
        /*不设置这个crossOrigin会报画布污染错误*/
        imgNew.crossOrigin = 'Anonymous'
        imgNew.onload = () => {
          context.drawImage(imgNew, 0, 0, canvas.width, canvas.height)
          /*绘制二维码*/
          const qrcode = new QRCode(this.$refs.qrcode, {
            text: this.QRCodeMsg,
            width: 108,
            height: 108,
            colorDark : "#000000",
            colorLight : "#ffffff",
            correctLevel : QRCode.CorrectLevel.H
          })
          qrcode._oDrawing._elImage.onload = ev => {
            let qrcodeImg = ev.target
            context.drawImage(qrcodeImg, canvas.width - 108 - 18, canvas.height - 108 - 18)
            let base64 = canvas.toDataURL('image/png')
            this.posterUrl = base64
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.posterWrapper{
  width: 100%;
  height: 100%;
}
.posterWrapper img{
  width: 100%;
  height: 100%;
} 
.posterCanvas{
  display: none;
  width: 250px;
  height: 400px;
}
.qrcode{
  display: none;
}
</style>
